<template>
  <button
    v-if="props.selectedPage < props.countOfPages"
    class="frisbuy-loadmore-button"
    :disabled="props.isLoadPosts"
    :aria-busy="props.isLoadPosts ? 'true' : 'false'"
    @click="() => selectPage(props.selectedPage + 1)"
  >
    <span
      v-if="props.isLoadPosts"
      class="frisbuy-loadmore-button__loader"
      aria-hidden="true"
    ></span>
    <span>Показать еще</span>
  </button>
</template>

<style scoped lang="scss">
.frisbuy-loadmore-button {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  margin-top: 40px;
  border-radius: 80px;
  padding: 10px 0;
  height: 40px;

  border: 1px solid var(--frisbuy-color-primary-5);

  width: 100%;
  background-color: transparent;

  font-size: 14px;
  line-height: 20px;
  font-weight: 400;
  color: var(--frisbuy-color-primary);

  cursor: pointer;

  &:disabled {
    opacity: 0.75;
    cursor: default;
  }

  &:hover {
    border: 1px solid var(--frisbuy-color-primary-7);
    color: var(--frisbuy-color-primary-7);
  }
}

.frisbuy-loadmore-button__loader {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid rgba(33, 33, 33, 0.25);
  border-top-color: rgba(33, 33, 33, 1);
  animation: frisbuy-loadmore-button-spin 0.8s linear infinite;
  flex: 0 0 auto;
}

@keyframes frisbuy-loadmore-button-spin {
  to {
    transform: rotate(360deg);
  }
}
</style>

<script setup lang="ts">
const props = defineProps({
  countOfPages: {
    type: Number,
    required: true,
    validator: (val: number) => val > 0,
  },

  selectedPage: {
    type: Number,
    required: true,
    validator: (val: number) => val >= 1,
  },

  isLoadPosts: {
    type: Boolean,
    required: true,
  },
});

const emit = defineEmits<{
  selectPage: [page: number];
}>();

function selectPage(page: number) {
  let pageForEmit = page;

  if (pageForEmit < 1) {
    pageForEmit = 1;
  } else if (pageForEmit > props.countOfPages) {
    pageForEmit = props.countOfPages;
  }

  if (pageForEmit === props.selectedPage) {
    return;
  }

  emit("selectPage", pageForEmit);
}
</script>
